<template>
  <div class="flex mb-2 mt-6" :class="!sent ? 'justify-start' : 'justify-end'" >
    <div class="flex items-start gap-2" :class="{ 'flex-row-reverse': !!sent }">
      <div class="w-8 h-8 mt-auto rounded-full flex items-center justify-center bg-blue-600 text-white text-xs font-bold shrink-0">
        {{ avatar }}
      </div>
      <div class="max-w-[70%]">
        <div v-if="!!name" class="text-slate-500 text-xs" :class="{ 'text-end': !!sent }">{{ name }}</div>
        <div class="rounded-lg px-3 py-2" :class="bgColor">
          <p class="text-sm">{{ text }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ChatMessage',

  props: {
    name: String,
    avatar: String,
    text: String,
    sent: Boolean,
    bgColor: {
      type: String,
      default: 'bg-blue-100'
    }
  },

  data () {
    return {
    }
  }
})
</script>

<style scoped>

</style>